module.exports = __webpack_public_path__ + "media/images/hp_quiz/social_windows-8b16e8a3f7ac3e744377ae7a25faa5d6.svg";